import React from "react";
import { Descriptions } from "antd";
import { useIntl } from "react-intl";

import "./index.css";

const { Item } = Descriptions;

const BoldText = ({ children }) => (
  <span className="last-state-title">{children}</span>
);

const LastState = ({ lastState }) => {
  const intl = useIntl();
  return (
    <Descriptions
      column={1}
      colon={false}
      layout="vertical"
      className="last-state-container"
      title={intl.formatMessage({
        id: "tracking.actualState",
        defaultMessage: "Aktuální stav zásilky",
      })}
    >
      <Item
        label={
          <BoldText>
            {intl.formatMessage({
              id: "tracking.actualState.message",
              defaultMessage: "Stav zásilky",
            })}
          </BoldText>
        }
      >
        {lastState.detailMessage || lastState.message}
      </Item>
      <Item
        label={
          <BoldText>
            {intl.formatMessage({
              id: "tracking.actualState.dateTime",
              defaultMessage: "Místo a čas",
            })}
          </BoldText>
        }
      >
        {`${lastState.dateTime}${
          lastState.place ? `, ${lastState.place}` : ""
        }`}
      </Item>
    </Descriptions>
  );
};

export default LastState;
